<template>
  <div class="partnet-point-show">
    <p v-if="isLoading">
      <Loading />
    </p>
    <template v-else>

      <div class="partnet-point-show__header d-flex justify-content-between align-items-center">
        <button class="s-p-3" @click="$router.back()">
          <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.28033 0.46967C8.5466 0.735936 8.5708 1.1526 8.35295 1.44621L8.28033 1.53033L1.811 8L8.28033 14.4697C8.5466 14.7359 8.5708 15.1526 8.35295 15.4462L8.28033 15.5303C8.01406 15.7966 7.5974 15.8208 7.30379 15.6029L7.21967 15.5303L0.21967 8.53033C-0.0465965 8.26406 -0.0708027 7.8474 0.147052 7.55379L0.21967 7.46967L7.21967 0.46967C7.51256 0.176777 7.98744 0.176777 8.28033 0.46967Z"
              fill="#666666" />
          </svg>
        </button>

        <div>{{ pageTitle }}</div>
        <div class="s-p-3"></div>
      </div>

      <div class="s-p-3 min-vh-100">

        <!-- 自定義項目組件以符合原始佈局 -->
        <div v-if="item.name" class="s-bg-white rounded rounded-2 d-flex align-items-center list__item mb-3">
          <div v-if="item.image" class="list__image px-3">
            <img :src="item.image" alt="" @error="$event.target.style.display='none'">
          </div>
          <div class="flex-fill px-3">
            <div class="list__title mb-2">{{ item.name }}</div>
            <template v-if="item.available_plans && item.available_plans.length > 0">
              <div v-for="plan in sortedAvailablePlans" :key="plan.id" class="s-text-xs mb-1 list__exchange list__exchange--with-badge">
                <span>
                  <span class="s-text-primary font-weight-bold">{{ plan.exchange.from.value }}</span>&nbsp;{{ plan.exchange.from.unit }}&nbsp;→&nbsp;<span
                    class="s-text-primary font-weight-bold">{{ plan.exchange.to.value }}</span>&nbsp;{{ plan.exchange.to.unit }}
                </span>
                <span v-if="plan.is_sold_out" class="badge badge-sold-out">兌畢</span>
              </div>
            </template>
          </div>
        </div>

        <div v-if="errorMessage" class="alert alert-danger mt-3">
          {{ errorMessage }}
        </div>

        <template v-if="step === 'init'">
          <div class="partnet-point-show__info">
            <ul class="partnet-point-show__info__range">
              <li v-if="currentPlanPeriods.exchange_period">兌換活動期間：{{ currentPlanPeriods.exchange_period.start }} - {{ currentPlanPeriods.exchange_period.end }}</li>
              <li v-if="currentPlanPeriods.code_period">序號兌換效期：{{ currentPlanPeriods.code_period.start }} - {{ currentPlanPeriods.code_period.end }}</li>
            </ul>

            <div class="divider my-2"></div>

            <div class="partnet-point-show__info__title">兌換注意事項</div>
            <div v-if="item.event_notes" class="notes-content" v-html="item.event_notes"></div>
          </div>
        </template>

        <template v-if="step === 'confirm'">
          <div class="divider mt-2">兌換序號</div>

          <div v-for="(code, idx) in sns" :key="idx"
            class="s-bg-white rounded rounded-2 d-flex align-items-center justify-content-between p-2 mb-1">
            <div class="serial-number font-weight-bold flex-fill text-center">{{ code }}</div>

            <!-- 異業商品兌換顯示「開啟」button -->
            <button v-if="isProductExchange"
              class="s-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3"
              @click="openBarcodeModal(code)">開啟</button>

            <!-- 異業點數兌換顯示「複製」button -->
            <CopyButton v-else
              :text="code"
              variant="logs"
              success-message="序號已複製到剪貼簿"
            />
          </div>


        </template>





      </div>


      <div class="footer p-3">
        <template v-if="step === 'init'">
          <div class="s-text-xs mb-3">可用點數 <span class="s-text-secondary s-text-xl">{{ userPoints.toLocaleString() }}</span></div>

          <div class="d-flex justify-content-between align-items-center">
            <div class="mr-3 flex-fill">
              <button class="s-btn s-btn-sm px-2 partnet-point-show__redeem-solution" v-if="eventIsPublicAccessible && hasRedeemablePlans" v-b-modal.modal-redeem-solution>{{ redeemSolution }}</button>
              <button class="s-btn s-btn-sm px-2 partnet-point-show__redeem-solution" v-else disabled>{{ redeemSolution }}</button>
            </div>
            <div>
              <b-form-spinbutton
                v-model="quantity"
                min="1"
                :max="maxRedeemableQuantity"
                :disabled="isInteractionDisabled"
              ></b-form-spinbutton>
            </div>
          </div>

          <div class="text-center my-2">
            <b-form-checkbox v-model="agreedTerms" size="sm" :disabled="isInteractionDisabled">
              我已同意注意事項
            </b-form-checkbox>
          </div>

          <button
            class="s-btn s-btn-primary s-btn-sm px-4"
            @click="redeem"
            :disabled="isRedeeming || isInteractionDisabled"
          >
            {{ isRedeeming ? '處理中...' : '確認' }}
          </button>
        </template>

        <template v-if="step === 'confirm'">
          <button class="s-btn s-btn-primary s-btn-sm px-4" @click="finish">完成</button>
        </template>
      </div>

    </template>

    <!-- 選擇兌換方案 -->
    <b-modal id="modal-redeem-solution" centered>
      <template #modal-header="{ close }">
        <div>選擇兌換方案</div>
        <!-- 模擬內建 modal 標題關閉按鈕動作 -->
        <b-button variant="link" @click="close()" class="close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
              fill="#666666" />
          </svg>
        </b-button>
      </template>

      <div class="px-3 pt-3">
        <b-form-radio
          v-for="(plan, idx) in sortedAvailablePlans"
          v-model="selectedPlan"
          :key="idx"
          :value="plan"
          class="mb-3"
          :disabled="plan.is_sold_out"
        >
          <template v-if="plan.exchange">
            {{ plan.exchange.from.value }} {{ plan.exchange.from.unit }} → {{ plan.exchange.to.value }} {{ plan.exchange.to.unit }}

            <span v-if="plan.is_sold_out" class="badge badge-sold-out ml-2">兌畢</span>
          </template>
        </b-form-radio>
      </div>

      <template #modal-footer="{ close }">
        <div class="w-100">
          <button class="s-btn s-btn-primary s-btn-sm px-4" @click="close()">確認</button>
        </div>
      </template>
    </b-modal>

    <!-- 使用共用 Barcode Popup 組件 -->
    <BarcodePopup
      :show="showBarcodeModal"
      :serial-number="selectedBarcode"
      @close="closeBarcodeModal"
      @copied="onBarcodeCopied"
    />

    <!-- Success Popup -->
    <SuccessPopup
      :show="showSuccessPopup"
      :message="successMessage"
      @close="showSuccessPopup = false"
    />

    <!-- Warning Popup -->
    <ErrorPopup
      :show="showWarningPopup"
      :title="warningMessage"
      :auto-close="2000"
      @close="showWarningPopup = false"
    />

    <!-- Error Popup -->
    <ErrorPopup
      :show="showErrorPopup"
      :title="errorPopupTitle"
      :description="errorPopupMessage"
      @close="showErrorPopup = false"
    />

    <!-- Confirm Popup -->
    <ConfirmPopup
      :show="showConfirmPopup"
      :title="confirmTitle"
      :description="confirmDescription"
      @confirm="handleConfirm"
      @cancel="showConfirmPopup = false"
    />

  </div>
</template>

<script>
import Loading from '@/components/Page/Liff/Shared/Loading'
import BarcodePopup from '@/components/Page/Web/PartnerMarketing/BarcodePopup.vue'
import CopyButton from '@/components/Page/Web/PartnerMarketing/CopyButton.vue'
import SuccessPopup from '@/components/Page/Web/PartnerMarketing/SuccessPopup.vue'
import ErrorPopup from '@/components/Page/Web/PartnerMarketing/ErrorPopup.vue'
import ConfirmPopup from '@/components/Page/Web/PartnerMarketing/ConfirmPopup.vue'
import webPartnerMarketing from '@/apis/web/partnerMarketing'

export default {
  components: { Loading, BarcodePopup, CopyButton, SuccessPopup, ErrorPopup, ConfirmPopup },
  data: () => ({
    item: {},
    selectedPlan: null,
    redeemSolution: '請選擇方案',
    step: 'init',
    sns: [],
    isLoading: true,
    errorMessage: '',
    userPoints: 0,
    quantity: 1,
    agreedTerms: false,
    showBarcodeModal: false,
    selectedBarcode: '',
    showSuccessPopup: false,
    successMessage: '',
    showWarningPopup: false,
    warningMessage: '',
    showErrorPopup: false,
    errorPopupTitle: '兌換失敗！',
    errorPopupMessage: '',
    showConfirmPopup: false,
    confirmTitle: '',
    confirmDescription: '',
    confirmCallback: null,
    isRedeeming: false
  }),
  computed: {
    isProductExchange() {
      // 根據 event type 判斷是否為商品兌換
      return this.item.type === 'product';
    },
    pageTitle() {
      return this.isProductExchange ? '異業商品兌換' : '異業點數兌換';
    },
    currentPlanPeriods() {
      // 返回選中 plan 的時間資訊，如果沒有選中則不顯示
      if (this.selectedPlan) {
        return {
          exchange_period: this.selectedPlan.exchange_period,
          code_period: this.selectedPlan.code_period
        };
      }
      return {
        exchange_period: null,
        code_period: null
      };
    },
    selectedPlanIsRedeemable() {
      if (!this.selectedPlan) {
        return false;
      }

      return this.planIsRedeemable(this.selectedPlan);
    },
    isInteractionDisabled() {
      return !this.selectedPlanIsRedeemable || !this.eventIsPublicAccessible;
    },
    maxRedeemableQuantity() {
      if (!this.selectedPlan) {
        return 0;
      }
      return Math.min(this.selectedPlan.available_codes_count, this.selectedPlan.per_user_exchange_limit)
    },
    eventIsPublicAccessible() {
      return !!(this?.item?.is_available || false)
    },
    hasRedeemablePlans() {
      return (this.item?.available_plans || []).some(this.planIsRedeemable)
    },
    // 排序後的方案列表（已兌畢方案排在最後）
    sortedAvailablePlans() {
      if (!this.item.available_plans) return [];

      return [...this.item.available_plans]
        .filter(plan => this.planIsPublicAccessible(plan))
        .sort((a, b) => {
          // 已兌畢的方案排在最後
          if (a.is_sold_out && !b.is_sold_out) return 1;
          if (!a.is_sold_out && b.is_sold_out) return -1;
          return 0;
        });
    }
  },
  async mounted() {
    document.title = this.pageTitle;
    this.isLoading = true;
    try {
      await Promise.all([
        this.fetch(),
        this.fetchUserPoints()
      ]);
    } catch (error) {
      console.error('Failed to load data:', error);
    } finally {
      this.isLoading = false;
    }
  },
  watch: {
    pageTitle(newTitle) {
      document.title = newTitle;
    },
    selectedPlan(newPlan) {
      if (newPlan && newPlan.exchange) {
        const exchange = newPlan.exchange;
        this.redeemSolution = `${exchange.from.value} ${exchange.from.unit} → ${exchange.to.value} ${exchange.to.unit}`;
      }
    }
  },
  methods: {
    planIsPublicAccessible(plan) {
      return plan?.is_available === true;
    },
    planIsRedeemable(plan) {
      // 方案可兌換 = is_available 為 true 且未兌畢
      return this.planIsPublicAccessible(plan) && plan?.is_sold_out !== true;
    },
    async fetch() {
      this.errorMessage = '';

      const id = this.$route.params.id;
      const response = await webPartnerMarketing.getRewardDetails(id);

      if (response.data.status === 'success') {
        this.item = response.data.data;
        // Auto select first available (not sold out) plan
        if (this.item.available_plans && this.item.available_plans.length > 0) {
          // 優先選擇第一個未兌畢的方案
          const firstAvailablePlan = this.sortedAvailablePlans.find(plan => !plan.is_sold_out);

          if (firstAvailablePlan) {
            this.selectPlan(firstAvailablePlan);
          } else {
            // 如果所有方案都已兌畢，選擇第一個方案（disabled 狀態）
            this.selectPlan(this.sortedAvailablePlans[0]);
          }
        }
      } else {
        this.errorMessage = response.data.message || '載入資料失敗';
      }
    },
    async fetchUserPoints() {
      try {
        const response = await webPartnerMarketing.getUserPoints();
        if (response.data.status === 'success') {
          this.userPoints = response.data.data.current_points;
        }
      } catch (error) {
        console.error('Failed to fetch user points:', error);
      }
    },
    selectPlan(plan) {
      this.selectedPlan = plan;
      // Set redeemSolution based on selected plan
      if (plan && plan.exchange) {
        const exchange = plan.exchange;
        this.redeemSolution = `${exchange.from.value} ${exchange.from.unit} → ${exchange.to.value} ${exchange.to.unit}`;
      }
    },
    async redeem() {
      // 檢查是否已選擇方案
      if (!this.selectedPlan) {
        this.warningMessage = "請先選擇方案";
        this.showWarningPopup = true;
        return;
      }

      // 檢查是否已同意條款
      if (!this.agreedTerms) {
        this.warningMessage = "請先同意注意事項";
        this.showWarningPopup = true;
        return;
      }

      const totalPoints = this.selectedPlan.exchange.from.value * this.quantity;

      // 檢查可用點數是否足夠
      if (totalPoints > this.userPoints) {
        this.warningMessage = "點數不足，無法兌換";
        this.showWarningPopup = true;
        return;
      }

      this.confirmTitle = `您目前有 ${this.userPoints.toLocaleString()} 點\n確定使用 ${totalPoints.toLocaleString()} 點兌換嗎？`;
      this.confirmDescription = '';
      this.confirmCallback = async () => {
        this.isRedeeming = true;
        try {
          const response = await webPartnerMarketing.redeem(this.selectedPlan.id, this.quantity);

          if (response.data.status === 'success') {
            this.sns = response.data.data.codes;
            this.step = 'confirm';

            this.successMessage = `已為您兌換 ${response.data.data.quantity} 個序號`;
            this.showSuccessPopup = true;
          } else {
            this.errorPopupMessage = response.data.message || "請稍後再試";
            this.showErrorPopup = true;
          }
        } catch (error) {
          console.error('Redeem error:', error);

          // 檢查是否為序號兌畢錯誤
          let errorTitle = "兌換失敗！";
          let errorMessage = "網路錯誤，請稍後再試";

          if (error.response && error.response.data) {
            const responseData = error.response.data;

            // 如果是序號兌畢錯誤，修改標題和訊息
            if (responseData.error_type === 'sold_out' || responseData.message === '序號已兌換完畢') {
              errorTitle = "兌換完畢";
              errorMessage = "序號已兌換完畢";
            } else if (responseData.message) {
              errorMessage = responseData.message;
            }
          }

          this.errorPopupTitle = errorTitle;
          this.errorPopupMessage = errorMessage;
          this.showErrorPopup = true;
        } finally {
          this.isRedeeming = false;
        }
      };
      this.showConfirmPopup = true;
    },
    finish() {
      // 完成後返回到 index 頁面
      this.$router.push({ name: 'WebPartnerMarketingIndex' });
    },
    openBarcodeModal(code) {
      this.selectedBarcode = code;
      this.showBarcodeModal = true;
    },
    closeBarcodeModal() {
      this.showBarcodeModal = false;
      this.selectedBarcode = '';
    },
    onBarcodeCopied() {
      // 可選擇是否關閉 modal
      // this.closeBarcodeModal()
    },
    handleConfirm() {
      this.showConfirmPopup = false;
      if (this.confirmCallback) {
        this.confirmCallback();
        this.confirmCallback = null;
      }
    }
  }
}
</script>

<style>
.s-container {
  padding-bottom: 0 !important;
}
</style>
<style lang="scss" scoped>
.partnet-point-show {
  margin: -1rem -0.75rem 0;

  &__header {
    background-color: var(--s-white);
    position: sticky;
    top: 0;
    z-index: 1000;
    line-height: 100%;
  }

  &__info {
    font-size: 14px;
    color: #333333;
    line-height: 150%;

    ol {
      padding-left: 1.5rem;
      list-style: decimal;
    }

    ul {
      padding-left: 1.5rem;
      list-style: disc;
    }

    ::v-deep .notes-content {
      // 超連結樣式
      a {
        color: #FE577F;
        text-decoration: underline;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      // 段落間距
      p {
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      // 列表樣式
      ol {
        padding-left: 1.5rem;
        list-style: decimal;
        margin-bottom: 0.5rem;
      }

      ul {
        padding-left: 1.5rem;
        list-style: disc;
        margin-bottom: 0.5rem;
      }

      // 表格樣式
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 0.5rem;

        td, th {
          border: 1px solid #E3E3E3;
          padding: 0.5rem;
        }
      }

      // 圖片樣式（確保不超出容器）
      img {
        max-width: 100%;
        height: auto;
        margin: 0.5rem 0;
      }
    }

    &__title {
      font-weight: 500;
      font-size: 14px;
    }

    &__range {
      font-weight: 500;

      li::marker {
        color: var(--s-primary);
      }
    }
  }

  &__point {
    font-weight: 500;
    font-size: 32px;
    color: black;
    line-height: 100%;
    padding: 1rem 0;

    > :first-child {
      border-right: 3px solid #E3E3E3;
    }
  }

  &__redeem-solution {
    border-radius: 0.25rem;
    border: 1px solid #cdd6dc;
    padding: 0.7rem 0.81rem;
    font-size: 1rem;
    font-weight: 400;
    justify-content: start;
  }



  .footer {
    position: sticky;
    bottom: 0;
    background-color: var(--s-white);
    z-index: 1000;
    padding: 1rem 0;
    border-top: 1px solid #E3E3E3;

    ::v-deep .custom-select {
      padding: 0.375rem 1.75rem 0.375rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      border-width: 1px;
      height: 45px;
    }

    ::v-deep .b-form-spinbutton {
      border-width: 1px;
      border-radius: 0.25rem;
      width: auto;

      >button {
        padding: 0.5rem 0.81rem;

        &:last-child {
          color: var(--s-primary);
        }
      }

      >output {
        padding: 0 1rem;
      }
    }

    ::v-deep .custom-checkbox {
      .custom-control-label::before {
        border-width: 1px;
      }

      .custom-control-input:checked~.custom-control-label::before {
        background-color: var(--s-primary);
        border-color: var(--s-primary);
      }
    }

  }
}

.s-text-secondary {
  color: #FE577F !important;
}

::v-deep .modal-backdrop {
  opacity: .5;
}

::v-deep .modal {

  --s-primary: #FE577F;




  &.fade .modal-dialog {
    transform: translateY(10%);
    transition: transform 0.3s ease-out;
  }

  &.show .modal-dialog {
    transform: translateY(0);
  }


  .modal-dialog {

    margin: auto;

    .modal-header {
      justify-content: center;
      align-items: center;
      position: relative;

      .close {
        position: absolute;
        right: 0;
        margin: 0;
      }
    }

    .modal-content {
      border-radius: .3rem .3rem 0 0;
      border: none;
    }

    &.modal-dialog-centered {
      align-items: end;

      min-height: calc(100%);

    }
  }

  .s-btn {
    color: white !important;
  }

  // Modal radio disabled 樣式
  .custom-control-input:disabled ~ .custom-control-label {
    color: #999;
    cursor: not-allowed;
  }
}

// 兌畢 badge 樣式
.badge-sold-out {
  background-color: #F7C8D6;
  color: white;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

// 兌畢通知區塊
.sold-out-notice {
  background-color: #F7C8D6;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;

  &__text {
    color: white;
    font-size: 18px;
    font-weight: 500;
  }
}

.list__item {
  margin-bottom: 12px;
  padding: 8px 0;
  box-shadow: 0px 2px 6px 0px #00000033;
}

.list__image {
  border-right: 1px solid #E3E3E3;

  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
}

.list__title {
  font-weight: 500;
  font-size: 16px;
}

.list__exchange {
  color: #333333;

  // 當有 badge 時使用 flex 布局處理換行間距
  &--with-badge {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;  // 統一處理水平和垂直間距
  }
}

.serial-number {
  font-size: 12px;
  word-break: break-all;
}


</style>
